package fyi.moko.hotpl.ui.detail

import fyi.moko.hotpl.domain.model.Place

/**
 * The photos the detail header pages through, cover first.
 *
 * 대표 사진이 맨 앞이어야 하는 이유는 헤더가 "이 가게가 어디였더라"에 답하는 자리이기
 * 때문이다 — 스와이프하기 전에 보이는 한 장이 곧 목록에서 보던 그 사진이어야 한다.
 *
 * [Place.imageFileName]만 있고 [Place.photos]가 빈 경우는 멀티 사진(스키마 v15) 이전에
 * 저장된 장소다. 그때는 대표 한 장이 전체 목록이 된다.
 *
 * Kept out of the Compose file so it can be tested without a UI toolkit.
 */
internal fun headerPhotoOrder(place: Place): List<String> {
    val all = place.photos.map { it.fileName }.filter { it.isNotBlank() }.distinct()
    val cover = place.imageFileName?.takeIf { it.isNotBlank() }
    return when {
        all.isEmpty() -> listOfNotNull(cover)
        cover == null || cover !in all -> all
        else -> listOf(cover) + all.filterNot { it == cover }
    }
}
